import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareR = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler22') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler22', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Lucky imp!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Lucky imp!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareR}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareR
  
